<div #seatComponent *ngIf="!seat.isPlaceholder" class="seat" [ngClass]="getSeatClass()" [isDisabled]="!tooltipEnabled">
  <button (click)="onOccupiedChange()" [disabled]="!isButtonActive()"></button>
</div>
